import { IRutinInfo } from '../../../../../Types/RutinInfoType';

const PUStyrvardeMeny: IRutinInfo[] = [];

export default PUStyrvardeMeny;
